/* tslint:disable */
/* eslint-disable */
/**
 * 80s Conservation Club REST API
 * 80s Conservation Club REST API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: graham@matthewsapps.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { MemberContactEmail } from './MemberContactEmail';
import {
    MemberContactEmailFromJSON,
    MemberContactEmailFromJSONTyped,
    MemberContactEmailToJSON,
} from './MemberContactEmail';
import type { Metadata } from './Metadata';
import {
    MetadataFromJSON,
    MetadataFromJSONTyped,
    MetadataToJSON,
} from './Metadata';

/**
 * 
 * @export
 * @interface GetAccountMembershipContactEmails200Response
 */
export interface GetAccountMembershipContactEmails200Response {
    /**
     * 
     * @type {Array<MemberContactEmail>}
     * @memberof GetAccountMembershipContactEmails200Response
     */
    data: Array<MemberContactEmail>;
    /**
     * 
     * @type {Metadata}
     * @memberof GetAccountMembershipContactEmails200Response
     */
    metadata: Metadata;
}

/**
 * Check if a given object implements the GetAccountMembershipContactEmails200Response interface.
 */
export function instanceOfGetAccountMembershipContactEmails200Response(value: object): value is GetAccountMembershipContactEmails200Response {
    if (!('data' in value) || value['data'] === undefined) return false;
    if (!('metadata' in value) || value['metadata'] === undefined) return false;
    return true;
}

export function GetAccountMembershipContactEmails200ResponseFromJSON(json: any): GetAccountMembershipContactEmails200Response {
    return GetAccountMembershipContactEmails200ResponseFromJSONTyped(json, false);
}

export function GetAccountMembershipContactEmails200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetAccountMembershipContactEmails200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'data': ((json['data'] as Array<any>).map(MemberContactEmailFromJSON)),
        'metadata': MetadataFromJSON(json['metadata']),
    };
}

export function GetAccountMembershipContactEmails200ResponseToJSON(value?: GetAccountMembershipContactEmails200Response | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'data': ((value['data'] as Array<any>).map(MemberContactEmailToJSON)),
        'metadata': MetadataToJSON(value['metadata']),
    };
}

